import { BaseSyntheticEvent, FC, ReactNode } from 'react';
import { Link } from 'react-router';
import { IconName } from '@connect-x-app/shared-types';
import { Icon, Spinner } from '@connect-x-app/web-ui';
import classnames from 'classnames';

import './button.scss';

type ButtonProps = {
  asText?: boolean;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  href?: string;
  iconName?: IconName;
  isOutline?: boolean;
  loading?: boolean;
  onClick?: (event?: BaseSyntheticEvent) => void;
  testId?: string;
  theme?: 'neutral' | 'primary' | 'login' | 'negative' | 'dark' | 'secondary' | 'transparent' | 'delete';
  type?: 'button' | 'submit' | 'reset';
};

export const Button: FC<ButtonProps> = ({
  asText,
  children,
  className = '',
  disabled,
  href,
  iconName,
  isOutline = false,
  loading,
  onClick = () => {},
  testId,
  theme = 'neutral',
  type = 'button',
}) => {
  const cssClasses = classnames(asText ? 'as-text' : 'buttonAdmin', className, theme, {
    disabled,
    loading,
    outline: isOutline,
  });

  const renderSpinner = () => {
    if (!loading) {
      return null;
    }
    return (
      <div className="spinner-wrapper">
        <Spinner theme={(asText ?? isOutline) ? 'normal' : 'inversed'} />
      </div>
    );
  };

  if (href) {
    return (
      <Link className={cssClasses} data-test={testId} to={href}>
        {iconName ? <Icon name={iconName} /> : null}
        {children}
        {renderSpinner()}
      </Link>
    );
  }
  return (
    <button className={cssClasses} data-test={testId} disabled={disabled} onClick={onClick || (() => {})} type={type}>
      {iconName ? <Icon name={iconName} /> : null}
      {children}
      {renderSpinner()}
    </button>
  );
};
